import { configureStore } from '@reduxjs/toolkit';
import credentialsReducer from './credentialsSlice';

const store = configureStore({
    reducer: {
        credentials: credentialsReducer
    }
});

export default store;

// const createReducer = asyncReducers => (state, action) => {
//
//     const combinedReducer = combineReducers({
//         credentialsReducer
//     });
//
//     /*
//     Reset the redux store when user logged out
//      */
//     if (action.type === 'auth/user/userLoggedOut') {
//         state = undefined;
//     }
//
//     return combinedReducer(state, action);
// };
//
// export default configureStore({
//     reducer: createReducer(),
// })